import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { handleApiRequestSuccessData, handleRequestError } from '../../utils/request';
import { api } from '../index';
export var apiCoversationClockIn = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.post("/client_messages/agent_clock_in", payload);

          case 3:
            res = _context.sent;
            handleApiRequestSuccessData(res);
            return _context.abrupt("return", [res.data]);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0, payload));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function apiCoversationClockIn(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var apiCoversationClockOut = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.post("/client_messages/agent_clock_out", payload);

          case 3:
            res = _context2.sent;
            handleApiRequestSuccessData(res);
            return _context2.abrupt("return", [res.data]);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0, payload));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function apiCoversationClockOut(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiGetCoversationAgentOnlineList = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.get("/client_messages/agent_online_list");

          case 3:
            res = _context3.sent;
            handleApiRequestSuccessData(res);
            return _context3.abrupt("return", [res.data]);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0, payload));

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function apiGetCoversationAgentOnlineList(_x3) {
    return _ref3.apply(this, arguments);
  };
}();